"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _BrixelIcon = _interopRequireDefault(require("../BrixelIcon"));
var _BrixelTooltip = _interopRequireDefault(require("../BrixelTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelCheckboxSingle = props => {
  const {
    cardLayout = false,
    cardSmall = false,
    className = '',
    classNameParent = '',
    disabled = false,
    icons = false,
    input,
    isHorizontal = false,
    isLoading = false,
    label = null,
    message = {
      help: null,
      error: null
    },
    meta = {
      dirty: false,
      invalid: false
    },
    modal = null,
    pdClass = '',
    option = null,
    options = null,
    tooltip,
    validation = false
  } = props;
  const [currentValue, setCurrentValue] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    setCurrentValue(input.value);
  }, [input.value]);
  const onChange = val => {
    let value = val;
    if (val === currentValue) value = false;
    setCurrentValue(value);
    if (input.onChange) input.onChange(value);
  };
  const OptionsComponent = (item, i) => {
    let defItem = item;
    if (item && item[0]) defItem = item[0];
    const {
      value,
      icon,
      color,
      backIcon,
      img
    } = defItem || {};
    const optionLabel = (0, _get.default)(defItem, 'label', '');
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `${className} ${icons ? 'brixel-checkbox-icon dis-f' : 'brixel-checkbox dis-f'}`
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: `${disabled ? 'disabled' : ''} ${value === currentValue ? 'checked' : ''} ${pdClass} ${color || ''}`,
      htmlFor: `${(0, _get.default)(input, 'name', '')}_${i} ${meta.dirty && meta.invalid && message.error && icons ? 'brdRed400 brdSmall' : ''}`,
      onClick: () => onChange(value),
      "data-testid": "singleCheckbox"
    }, /*#__PURE__*/_react.default.createElement("input", {
      onChange: () => '',
      role: "checkbox",
      className: "notranslate",
      "data-validation": validation,
      disabled: disabled,
      type: "checkbox",
      id: `${(0, _get.default)(input, 'name', '')}_${i}`,
      value: value ? value.toString() : undefined,
      name: (0, _get.default)(input, 'name', ''),
      checked: value === currentValue
    }), icons ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: `${cardLayout ? 'dis-fl-col col-reverse jc-c a-c w-perc-100' : 'dis-f a-c'}`
    }, icon && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      color: backIcon || 'primary',
      saturationTxt: 700,
      background: backIcon || 'primary',
      saturation: 200,
      icon: icon
    })), img && (/*#__PURE__*/_react.default.createElement("img", {
      className: "",
      src: img,
      alt: optionLabel
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: `textLabel ${cardLayout ? 'pt-2 pb-3 max-w-fix-184 ta-c' : ''} ${icon ? 'ml-1' : ''}`,
      dangerouslySetInnerHTML: {
        __html: optionLabel || ''
      }
    })), isLoading ? (/*#__PURE__*/_react.default.createElement("div", {
      className: "btnLoader loading"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "lds-ring"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "brdAniPrimary400"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "brdAniPrimary400"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "brdAniPrimary400"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "brdAniPrimary400"
    })))) : (/*#__PURE__*/_react.default.createElement("span", {
      className: "checkmark"
    }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      color: "white",
      icon: "check",
      className: 'pl-small-1'
    }))))) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: "checkmark"
    }, isLoading && (/*#__PURE__*/_react.default.createElement("div", {
      className: "btnLoader loading"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "lds-ring"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "brdAniPrimary400"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "brdAniPrimary400"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "brdAniPrimary400"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "brdAniPrimary400"
    })))), /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      color: "white",
      icon: "check",
      className: 'pl-small-1'
    })), /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: optionLabel || ''
      }
    })))));
  };
  const optionField = option || options;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label && (/*#__PURE__*/_react.default.createElement("label", {
    className: "brixel-label",
    "data-testid": "label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `va-tb ${tooltip ? 'mr-1' : ''}`
  }, label), tooltip && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    label: tooltip.label,
    width: tooltip.width,
    description: tooltip.description,
    theme: tooltip.theme
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: `${cardLayout ? 'cardLayout jc-c' : ''} ${cardSmall ? 'cardSmall' : ''} ${isHorizontal ? 'dis-fl-row' : 'dis-fl-col'} ${classNameParent}`
  }, OptionsComponent(optionField, input.name)), (message.help || meta.invalid) && (/*#__PURE__*/_react.default.createElement("span", {
    className: `message ${meta.dirty && meta.invalid ? 'error-message' : ''}`
  }, meta.dirty && meta.invalid ? message.error : message.help)), modal && (/*#__PURE__*/_react.default.createElement("span", {
    onClick: e => modal.func ? modal.func(e) : '',
    className: "message cur-poi"
  }, modal.message)));
};
var _default = exports.default = BrixelCheckboxSingle;